module.exports = __webpack_public_path__ + "static/media/img97_R.7f352095.jpg";